// Misc functions often called from controllers (example controller from Cocos, main.controller of designerApp, designer.controller of HomePlannerFront and sandboxController of HomePlannerBackOffice)
// Goal is to centralize those function in order not to copy a code X times in various controllers
import { ArrangementGroup, ArrangementObject, Commands, EntityFactory, Floor, JSONImporter, JSONSerializer, math, RenderCamera, roomManager, Scene, SceneConstants } from "@rhinov/savane-js";
import { EntityManager } from "../cocos/scripts/plan/EntityManager";
import { PlanManager } from "../cocosPlan";
import { _ASSET_TYPE, createAssetEntity } from "@rhinov/asset-manager-service";



export var CocosUtils =
{
    cleanWorldTemplates: function() {
        var allArrangements = PlanManager.getInstance().world.arrangementObjects;
        var arrayToClean = [];

        for (var i = 0 ; i < allArrangements.length ; i++) {
            if (allArrangements[i].manufacturer._id === '5df89bb3c5b06666d1a38703') {
                arrayToClean.push(allArrangements[i]);
            }
        }

        if (arrayToClean.length > 0) {
            PlanManager.getInstance().executeCommand(new Commands.DeleteEntitiesCommand(arrayToClean));
        }
    },

    filterFloor: function(scene: Scene, camera: RenderCamera, floor: Floor) {
        if (camera.cameraType !== SceneConstants.CameraType.Axonomic) {
            return scene;
        }

        //copy scene
        var newScene = JSONImporter.importScene(scene);
        var floorsToDelete = [];
        for (var i = 0; i < newScene.floors.length; ++i) {
            if (newScene.floors[i].id !== floor.id && newScene.floors[i].height > floor.height) {
                floorsToDelete.push(newScene.floors[i]);
            }
        }
        for (var i = 0; i < floorsToDelete.length; ++i) {
            newScene.deleteFloor(floorsToDelete[i].id);
        }

        return JSONSerializer.serializeEntity(newScene);
    },

    // Function to render a savane camera
    renderCamera: function(http: any, cameraId: number, isPreview: boolean, renderURL: string, params: any, successCallback: CallableFunction, errorCallback: CallableFunction) {
        var renderCamera: RenderCamera | null = null;
        var floorRenderCamera: Floor | undefined;
        var nightAndDay = false;
        var sceneCamera: Scene | null = null;
        var index = 0;

        // deep copy scene
        var json = JSONSerializer.serializeEntity(PlanManager.getInstance().world)
        var world = JSONImporter.importWorld(json);

        for (var k = 0; k < world.children.length; ++k) {
            var scene = world.children[k] as Scene;
            if (cameraId > 0) {
                var floors = scene.floors;
                for (var i = 0; i < floors.length; i++) {
                    for (var j = 0; j < floors[i].renderCameras.length; j++) {
                        if (floors[i].renderCameras[j].id !== cameraId) {
                            (floors[i].renderCameras[j] as any).disable = true;
                        } else {
                            (floors[i].renderCameras[j] as any).disable = false;
                            renderCamera = floors[i].renderCameras[j];
                            floorRenderCamera = floors[i];
                            sceneCamera = scene;
                            index = k;
                        }
                    }
                }
            }
        }

        if (renderCamera === null) {
            errorCallback('Caméra non trouvée...');
            return;
        }

        // Check that camera is actve for the rendering
        if (renderCamera.renderType === 0) {
            successCallback('Caméra inactive, rendu ignoré.');
            return;
        }

        // Render day + night, let's start with day
        if (renderCamera.renderType === 3) {
            renderCamera.renderType = 1;
            nightAndDay = true;
        }

        var qualityPath = 'preview/';
        // Get quality from camera only if not preview (if so select worst quality to have quick rendering)
        if (!isPreview) {
            switch ((renderCamera as any)._quality) {
                case 0:
                    qualityPath = 'uggly/';
                    break;
                case 1:
                    qualityPath = 'average/';
                    break;
                case 2:
                    qualityPath = 'good/';
                    break;
                case 3:
                    qualityPath = 'great/';
                    break;
            }
        }

        renderURL += qualityPath;

        if (renderCamera.cameraType === SceneConstants.CameraType.Panoramic) {
            renderCamera.renderHeight = renderCamera.renderWidth * 4;
            renderCamera.renderWidth = renderCamera.renderWidth * 3;
            // Make 100% sure the camera pitch of pano cameras is 0
            renderCamera.pitch = 0;
        }

        if (isPreview) {
            (renderCamera as any)._renderWidth /= 3;
            (renderCamera as any)._renderHeight /= 3;
            renderCamera.isFinalRender = false;
        }

        var toSend: any;

        if (params !== null) {
            toSend = {
                projectid: params.projectid,
                deliverableid: params.deliverableid,
                userid: params.userid,
                email: params.email,
                id: params.deliverableid,
                index: index,
                rhinov_format: CocosUtils.filterFloor(JSONSerializer.serializeEntity(sceneCamera!), renderCamera!, floorRenderCamera!)
            };
        }
        else {
            toSend = {
                rhinov_format: CocosUtils.filterFloor(JSONSerializer.serializeEntity(sceneCamera!), renderCamera!, floorRenderCamera!)
            };
        }

        var cameraText: string = '';
        switch (renderCamera.cameraType) {
            case SceneConstants.CameraType.Perspective:
            case SceneConstants.CameraType.PhotoRender:
                cameraText = 'After ';
                break;

            case SceneConstants.CameraType.Storage:
                cameraText = 'Rangement ';
                break;

            case SceneConstants.CameraType.Panoramic:
                cameraText = 'Pano ';
                break;

            case SceneConstants.CameraType.Axonomic:
                cameraText = 'Axo ';
                break;
        }
        cameraText += renderCamera.cameraNb + ' - ';

        http.post(renderURL,
            JSON.stringify(
                toSend
            ),
            {
                headers: {
                    "Content-Type": 'application/json',
                    "Authorization": undefined
                },
                timeout: 60000
            }).then(function(_response: any) {
                if (nightAndDay) {
                    if (renderCamera!.cameraType === SceneConstants.CameraType.Axonomic) {
                        if (successCallback !== null) {
                            successCallback('envoyé avec succès', cameraText + 'Jour');
                        }
                    }
                    else {
                        renderCamera!.renderType = 2;
                        toSend.rhinov_format = CocosUtils.filterFloor(JSONSerializer.serializeEntity(sceneCamera!), renderCamera!, floorRenderCamera!);

                        if (http.defaults.headers.common['x-api-key'] !== undefined) {
                            delete http.defaults.headers.common['x-api-key'];
                        }

                        http.post(renderURL,
                            JSON.stringify(
                                toSend
                            ),
                            {
                                headers: {
                                    "Content-Type": 'application/json',
                                    "Authorization": undefined
                                },
                                timeout: 60000
                            }).then(function(_response: any) {
                                if (successCallback !== null) {
                                    successCallback('envoyé avec succès', cameraText + 'Jour+Nuit');
                                }
                            }, function(response: any) {
                                if (errorCallback !== null) {
                                    errorCallback(' erreur rendu : ' + response.statusText + ' (' + response.status + ')', cameraText + 'Nuit');
                                }
                            });
                    }
                }
                else {
                    switch (renderCamera!.renderType) {
                        case 1:
                            cameraText += 'Jour ';
                            break;

                        case 2:
                            cameraText += 'Nuit ';
                            break;
                    }

                    if (successCallback !== null) {
                        successCallback('envoyée avec succès', cameraText);
                    }
                }
            }, function(response: any) {
                switch (renderCamera!.renderType) {
                    case 1:
                        cameraText += 'Jour ';
                        break;

                    case 2:
                        cameraText += 'Nuit ';
                        break;
                }

                if (errorCallback !== null) {
                    errorCallback('erreur rendu : ' + response.statusText + ' (' + response.status + ')', cameraText);
                }
            });
    },

    // Function that creates an image from an entity group (will be posted to our Asset Manager as a topview)
    generateTemplateScreenshot: function(group: any) {
        // Loop variable
        var i;
        //Generate image
        var canvas = document.createElement('canvas');
        //Generate canvas as maxed square
        var maximalSize = group.width > group.length ? group.width : group.length;
        maximalSize = Math.round(maximalSize) + 1;
        var scale = 224 / maximalSize;
        maximalSize = 256;
        canvas.width = maximalSize;
        canvas.height = maximalSize;
        var center = group.transform.globalPosition;

        var ctx = canvas.getContext("2d");
        // Create gradient

        var grd = ctx!.createRadialGradient(maximalSize / 2, maximalSize / 2, maximalSize / 4, maximalSize / 2, maximalSize / 2, maximalSize / 2);
        grd.addColorStop(0, "#d1d1d1");
        grd.addColorStop(1, "#a3a3a3");
        // Fill with gradient
        ctx!.fillStyle = grd;
        ctx!.fillRect(0, 0, maximalSize, maximalSize);
        ctx!.translate(maximalSize / 2, maximalSize / 2);

        // Array of entities we will have to draw (flat array instead of tree)
        var entityArray: any[] = [];

        var fillEntityArray = function(entity: any) {
            if (entity.entityType === SceneConstants.EntityType.ArrangementObject) {
                entityArray.push(entity);
            }
            else {
                for (var i = 0; i < entity.children.length; i++) {
                    fillEntityArray(entity.children[i]);
                }
            }
        };

        fillEntityArray(group);

        // Z sorted array we will have to draw (getLevel sorted)
        var sortedArray = [];

        while (entityArray.length !== 0) {
            var minZ = EntityManager.getInstance().getLevel(entityArray[0]);
            var idx = 0;

            for (i = 1; i < entityArray.length; i++) {
                if (EntityManager.getInstance().getLevel(entityArray[i]) < minZ) {
                    minZ = EntityManager.getInstance().getLevel(entityArray[i]);
                    idx = i;
                }
            }

            sortedArray.push(entityArray[idx]);
            entityArray.splice(idx, 1);
        }

        //TODO Fix context for subgroup
        var drawEntity = function(entity: any, ctx: any) {
            var node = EntityManager.getInstance().getNode(entity)!;

            ctx.save();
            //translation
            var translateX = (entity.transform.globalPosition[0] - center[0]) * scale;
            var translateY = -(entity.transform.globalPosition[1] - center[1]) * scale;
            ctx.translate(translateX, translateY);
            //rotation
            ctx.rotate(-node.arrangement.transform.globalZRotation);
            //Draw image
            ctx.drawImage(node.getImgHtmlElement(), -entity.length * 0.5 * scale, -entity.width * 0.5 * scale, entity.length * scale, entity.width * scale);
            ctx.restore();
        };

        for (i = 0; i < sortedArray.length; i++) {
            drawEntity(sortedArray[i], ctx);
        }

        var base64 = canvas.toDataURL("image/jpeg", 1.0).slice('data:image/jpeg;base64,'.length);
        var byteCharacters = atob(base64);

        var byteNumbers = new Array(byteCharacters.length);
        for (i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blobImage = new Blob([byteArray.buffer], { type: 'image/jpeg' });
        (blobImage as any).filename = 'preview1.jpg';

        return blobImage;
    },

    replaceSelectedArrangement: function(resource: any) {
        var planManager = PlanManager.getInstance();

        if (planManager.selectedEntities.length >= 1) {
            var assetType = _ASSET_TYPE.ARRANGEMENTS;

            // Arrangement group
            if (!resource.kind)
            {
                assetType = _ASSET_TYPE.TEMPLATES;
            }

            createAssetEntity(assetType, resource, true, function(newEntity: any) {
                var entitiesArray = planManager.selectedEntities.slice();

                var oldEntities: any[] = [];
                var newEntitiesAndParents: any[] = [];

                for (var i = 0; i < entitiesArray.length; i++) {
                    var selectedEntity = entitiesArray[i];

                    if (selectedEntity instanceof ArrangementObject || selectedEntity instanceof ArrangementGroup) {
                        var entity = EntityFactory.getInstance().cloneEntity(newEntity, true) as ArrangementGroup | ArrangementObject;

                        // We want the final replacing entity to be same id the original entity
                        entity.id = selectedEntity.id;
                        // End override entity id

                        var position = selectedEntity.position;

                        math.mat4.copy(entity.transform.localMatrix, selectedEntity.transform.globalMatrix);
                        // Adjust position depending on previous and new object height to keep the bottom of the object at the same place
                        if (selectedEntity.anchor && selectedEntity.anchor[1] === -3) {
                            position[2] += (selectedEntity.height - entity.height) / 2;
                        } else {
                            position[2] -= (selectedEntity.height - entity.height) / 2;
                        }
                        entity.position = position;
                        entity.isAnchorActive = selectedEntity.isAnchorActive;
                        var scale = math.vec3.create();
                        math.vec3.set(scale, 1, 1, 1);
                        entity.transform.localScale = scale;

                        // Get parent to attach object to
                        var parent: any = selectedEntity.parent;
                        // No parent found
                        if (parent === null) {
                            // Fallback find room for this object
                            parent = roomManager.getRoomAtPosition(entity.position, planManager.world.currentScene!.currentFloor!);
                            // No parent
                            if (parent === null) {
                                // Fallback with current floor
                                parent = planManager.world.currentScene!.currentFloor;
                            }
                        }

                        entity.updateFloorHeightFromAnchor(roomManager.getRoomAtPosition(entity.position, planManager.world.currentScene!.currentFloor!)!, planManager.world.currentScene!.currentFloor!);

                        oldEntities.push(selectedEntity);
                        newEntitiesAndParents.push({ entity: entity, parent: parent });
                    }
                }

                planManager.executeCommand(new Commands.ReplaceEntitiesCommand(oldEntities, newEntitiesAndParents));
            });
        }
    },

    _getSameResources: function(resources: any, objectType: string) {
        var result = [];
        for (var i = 0; i < resources.length; ++i) {
            var resource = resources[i];
            if (resource.objectType._id === objectType) {
                result.push(resource);
            }
        }
        return result;
    },

    _useSameObject: function(objectType: string): boolean {
        switch (objectType) {
            case "5bc08f3cefe98c5c27d0a81b": //affiches - cadres
                return false;
        }
        return true;
    },

    replaceSelectedArrangementWithShoppingList: function(resources: any) {
        var planManager = PlanManager.getInstance();
        var selection = planManager.selectedEntities.slice();
        var groups = selection.filter(function(item) {
            return item.isArrangementGroupEntity();
        });
        selection = selection.filter(function(item) {
            return item.isArrangementObjectEntity();
        });
        for (var i = 0; i < groups.length; ++i) {
            selection = selection.concat((groups[i] as any).arrangementObjectsRec as ArrangementObject[]);
        }
        if (selection.length === 0) {
            selection = planManager.scene.currentFloor!.arrangementObjectsRec;
        }

        var oldEntities: any[] = [];
        var newEntitiesAndParents: any[] = [];
        var useCount = 0;
        var objectTypeMap = new Map();
        // init use count
        for (var i = 0; i < resources.length; ++i) {
            resources[i].useCount = useCount;
        }
        for (var i = 0; i < selection.length; ++i) {
            var entity = selection[i] as ArrangementObject;
            var candidates = this._getSameResources(resources, entity.objectType);
            if (candidates.length === 0) continue;
            //random placeholder
            var selected = null;
            if (!entity.manufacturer || entity.manufacturer.name === "Placeholders") {
                var index = Math.floor(Math.random() * Math.floor(candidates.length));
                selected = candidates[index];
            } else {
                // same object type replaced by same object
                if (this._useSameObject(entity.objectType) && objectTypeMap.has(entity.objectId)) {
                    selected = objectTypeMap.get(entity.objectId);
                } else {
                    //
                    var filtered = candidates.filter(function(item) {
                        return item.useCount == useCount;;
                    });
                    if (filtered.length === 0) {
                        useCount++;
                    } else {
                        candidates = filtered;
                    }
                    var index = Math.floor(Math.random() * Math.floor(candidates.length));
                    selected = candidates[index];
                    selected.useCount++;
                    objectTypeMap.set(entity.objectId, selected);
                }
            }
            createAssetEntity(_ASSET_TYPE.ARRANGEMENTS, selected, true, function(newEntity: any) {
                var nentity = EntityFactory.getInstance().cloneEntity(newEntity, true) as ArrangementObject;

                // Get parent to attach object to
                var parent: any = entity.parent;
                // No parent found
                if (parent === null) {
                    // Fallback find room for this object
                    parent = roomManager.getRoomAtPosition(nentity.position, planManager.world.currentScene!.currentFloor!);
                    // No parent
                    if (parent === null) {
                        // Fallback with current floor
                        parent = planManager.world.currentScene!.currentFloor;
                    }
                }

                math.mat4.copy(nentity.transform.localMatrix, entity.transform.globalMatrix);
                nentity.isAnchorActive = entity.isAnchorActive;

                var position = math.vec3.clone(nentity.localPosition);
                if (entity.anchor && entity.anchor[1] === -3) {
                    position[2] += (entity.height - nentity.height) / 2;
                } else {
                    position[2] = position[2] - entity.height / 2 + nentity.height / 2;
                }
                nentity.localPosition = position;

                nentity.updateFloorHeightFromAnchor(roomManager.getRoomAtPosition(nentity.position, planManager.world.currentScene!.currentFloor!)!, planManager.world.currentScene!.currentFloor!);

                oldEntities.push(entity);
                newEntitiesAndParents.push({ entity: nentity, parent: parent });
            });
        }
        if (oldEntities.length > 0) {
            var command = new Commands.ReplaceEntitiesCommand(oldEntities, newEntitiesAndParents);
            planManager.executeCommand(command);
        }
    }
};
